import { AlertColor } from "@mui/material";
import { cloneDeep } from "lodash";
import { Toast } from "../models";
import preval from "preval.macro";
import moment from "moment";

export function replaceSpacesWithUnderscores(fileName) {
  return fileName.replace(/\s+/g, '_');
}